// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/exchange.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { Transceiver, TransceiverJson } from "./transceiver_pb";
import { file_mochabugapis_adapt_graph_transceiver } from "./transceiver_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/exchange.proto.
 */
export const file_mochabugapis_adapt_graph_exchange: GenFile = /*@__PURE__*/
  fileDesc("Cidtb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvZXhjaGFuZ2UucHJvdG8SGG1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaCLoAwoIRXhjaGFuZ2USLQoEbmFtZRgBIAEoCUIfukgcchoQARgyMhReW18kYS16XVtfJGEtejAtOV0qJBIiCgtkZXNjcmlwdGlvbhgCIAEoCUIIukgFcgMY+gFIAIgBARLCAQoMdHJhbnNtaXR0ZXJzGAMgAygLMiUubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLlRyYW5zY2VpdmVyQoQBukiAAboBeAoZdHJhbnNtaXR0ZXJzX3VuaXF1ZV9uYW1lcxIpRWFjaCB0cmFuc21pdHRlciBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aMHRoaXMubWFwKHRyYW5zbWl0dGVyLCB0cmFuc21pdHRlci5uYW1lKS51bmlxdWUoKZIBAhAKErMBCglyZWNlaXZlcnMYBCADKAsyJS5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGguVHJhbnNjZWl2ZXJCebpIdroBbAoWcmVjZWl2ZXJzX3VuaXF1ZV9uYW1lcxImRWFjaCByZWNlaXZlciBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aKnRoaXMubWFwKHJlY2VpdmVyLCByZWNlaXZlci5uYW1lKS51bmlxdWUoKZIBBAgBEApCDgoMX2Rlc2NyaXB0aW9uYgZwcm90bzM", [file_buf_validate_validate, file_mochabugapis_adapt_graph_transceiver]);

/**
 * Exchange represents a communication setup involving both transmitters and receivers.
 *
 * @generated from message mochabugapis.adapt.graph.Exchange
 */
export type Exchange = Message<"mochabugapis.adapt.graph.Exchange"> & {
  /**
   * Identifier for the exchange, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional descriptive text for the exchange, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * Outputs involved in the exchange, limited to 10 unique transmitters.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Transceiver transmitters = 3;
   */
  transmitters: Transceiver[];

  /**
   * Inputs involved in the exchange, requiring between 1 and 10 unique receivers.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Transceiver receivers = 4;
   */
  receivers: Transceiver[];
};

/**
 * Exchange represents a communication setup involving both transmitters and receivers.
 *
 * @generated from message mochabugapis.adapt.graph.Exchange
 */
export type ExchangeJson = {
  /**
   * Identifier for the exchange, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional descriptive text for the exchange, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * Outputs involved in the exchange, limited to 10 unique transmitters.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Transceiver transmitters = 3;
   */
  transmitters?: TransceiverJson[];

  /**
   * Inputs involved in the exchange, requiring between 1 and 10 unique receivers.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Transceiver receivers = 4;
   */
  receivers?: TransceiverJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.Exchange.
 * Use `create(ExchangeSchema)` to create a new message.
 */
export const ExchangeSchema: GenMessage<Exchange, ExchangeJson> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_exchange, 0);

